import { ServiceError, ToManyError, ValidateError } from './ServiceError';

const ENV: string = (process.env.NODE_ENV as string)

/**
 * APIコール
 */
export const callApi:any = (url:string, method:string, headers:any={}, body:any={}) => {
      
    // 接続オプション
    let options: any = {
        method: method.toUpperCase(),
        cache: 'no-cache',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        }
    }
    // 追加ヘッダー
    Object.keys(headers).forEach((key) => {
        options.headers[key] = headers[key];
    });
    if (process.env.NODE_ENV === 'development') {
        options.headers['Authorization'] = 'Basic ' + process.env.REACT_APP_BASIC_AUTHENTICATION;
    }
    //
    if (options.method === "POST"
        || options.method === "PUT"
        || options.method === "PATCH"
        || options.method === "DELETE") {
        options['body'] = JSON.stringify(body);
    }
    if (process.env.NODE_ENV === 'development') {
       options['mode'] = 'cors';
       delete options['credentials'];
       
       console.log(options);
       console.log('実行API(common)'+url)
    }
    // API実行
    return fetch(url, options)
        .then(async(response: any) => {
            if (process.env.NODE_ENV === 'development') {
                console.log(response);
            }
            if (response.ok) {
                return (response.status===204)?{}:response.json();
            } else if (response.status===400) {
                const message = await response.json();
                throw new ValidateError(message);
            } else if (response.status===413) {
                const message = await response.json();
                throw new ToManyError(message, response.status);
            } else {
                const message = await response.text();
                throw new ServiceError(message, response.status);
            }
        });
};